import axios from 'axios';
import { USERAPI_URL, USERMASTERAPIHOME } from './Config';


const header = { 'content-type': 'application/json' };
class UserPageService {

    constructor() {

        // UserPage
        this.GetUserData = (payload) => (axios.post(`${USERAPI_URL}userdb/getuserdata`, payload, header));
        this.GetAuthenticationTypeDDL = () => (axios.post(`${USERAPI_URL}userdb/getauthenticationtype`, "", header));
        this.GetAreaDDL = (payload) => (axios.post(`${USERAPI_URL}userdb/getArea`, payload, header));
        this.saveUser = (payload) => (axios.post(`${USERAPI_URL}userdb/saveupdateUserdetails`, payload, header));
        this.saveUserConfigure = (payload) => (axios.post(`${USERAPI_URL}userdb/saveuserdataaccessdetails`, payload, header));
        this.GetUserEditData = (payload) => (axios.post(`${USERAPI_URL}UserDB/getUserdetailsbyid`, payload, header));
        this.GetUserConfigureApplicaionName = (payload) => (axios.post(`${USERAPI_URL}userdb/getapplicationnames`, payload, header));
        this.GetUserConfigureApplicaionRole = (payload) => (axios.post(`${USERAPI_URL}userdb/getapplicationRole`, payload, header));
        this.GetUserConfigureFilterCriteria = (payload) => (axios.post(`${USERAPI_URL}userdb/getfilterdata`, payload, header));
        this.GetUserConfigurationDetials = (payload) => (axios.post(`${USERAPI_URL}userdb/getuserconfigurationdetails`, payload, header));
        this.saveUserActivate = (payload) => (axios.post(`${USERAPI_URL}userdb/updateuserstatus`, payload, header));
        this.GetProjectApplication = (payload) => (axios.post(`${USERMASTERAPIHOME}getactiveapplications`, payload, header));
        this.GetApplicationURL = (payload) => (axios.post(`${USERMASTERAPIHOME}getApplicationURL`, payload, header));
        // this.UserLogin = (payload) => axios.post('http://localhost:24663/api/UserMaster/callloginapi', payload, { headers: { 'Content-Type': 'application/json' } });

        // Login Page

        //  this.UserLogin = (payload) => axios.post('http://localhost:24663/api/UserMaster/callloginapi', payload, header);
        //   this.getsettings = () => (axios.post(`http://localhost:24663/api/UserMaster/getsettings`, null))
         // this.getsettings = () => (axios.post(`http://localhost:24663/api/UserMaster/getsettings`, null))

        this.UserLogin = (payload) => (axios.post(`${USERMASTERAPIHOME}Login`, payload, header));

        this.UserLogOut = () => (axios.post(`${USERMASTERAPIHOME}logout`));

        this.getsettings = () => (axios.post(`${USERMASTERAPIHOME}getsettings`, null));

        // this.CallForgetPasswordAPI = (userId) => (axios.post(`${USERMASTERAPIHOME}forgetpasswordapi`, { userId }));

        // this.CallResetPasswordAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}resetpasswordapi`, payload));

        // Changed on 22/Apr/26
        this.CallForgetPasswordAPI = (userId) => (axios.post(`${USERMASTERAPIHOME}forgetpasswordapi`, { userId }, header));
        this.CallResetPasswordAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}resetpasswordapi`, payload, header));

        this.ValidateFEDuser = (payload) => (axios.post(`${USERMASTERAPIHOME}validatefeduser`, payload));
        

    }
}
export default new UserPageService();